import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import { CounterpartyMonitoring } from '../../../../../containers/Blotters/CounterpartyMonitoring/CounterpartyMonitoring';
import type { CounterpartyMonitoringPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function CounterpartyMonitoringPanel({ params, api }: LayoutPanelProps<CounterpartyMonitoringPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.CounterpartyMonitoring}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="counterparty-monitoring-panel"
      >
        <CounterpartyMonitoring />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
